import React from 'react';

import { Box } from '@atlaskit/primitives';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

import { CharlieTable } from '@atlassian/charlie-table/compiled';
import type { ColumnDef } from '@atlassian/charlie-table/tanstack-helpers';

import type { ContentMetricRow } from './ContentMetricsTable.tsx';

const styles = cssMap({
	table: {
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		overflow: 'hidden',
	},
	headerCell: {
		font: token('font.heading.xxsmall'),
	},
});

export interface ContentMetricsEmptyStateProps {
	columnDefs: ColumnDef<ContentMetricRow>[];
}

// TODO: Update empty state content (this is a placeholder)
export const ContentMetricsEmptyState = ({ columnDefs }: ContentMetricsEmptyStateProps) => {
	return (
		<Box xcss={styles.table}>
			<CharlieTable<ContentMetricRow>
				columnDefs={columnDefs}
				data={[]}
				headerCellXcss={styles.headerCell}
			/>
		</Box>
	);
};
